.textCenter {
	text-align: center;
}

.liftClicks {
	position: relative;
	z-index: 2;
}

.truncate {
	width: 0;
	min-width: 100%;
	overflow-x: clip;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.textCaption {
	font-size: var(--font-size-caption);
}

.textBold {
	font-weight: bold;
}

.textId {
	font-size: var(--text-caption);
	font-family: var(--font-mono);
	color: rgb(from currentColor r g b / 75%);
}

.minWidth0 {
	min-width: 0;
}

.shrink0 {
	flex-shrink: 0;
}

.visuallyHidden {
	position: absolute;
	height: 1px;
	width: 1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
}

.wrapper {
	display: contents;
}

.card {
	border-radius: var(--radius-lg);
	background-color: var(--color-surface);
	background-clip: padding-box;
	overflow: clip;
	box-shadow: var(--shadow-md);
}
